<template>
  <article>
    <section class="w-full">
      <div class="banner w-full lg:h-18 h-60 relative">
        <div class="flex items-center flex-column w-full h-full">
          <div class="container mx-auto">
            <div class="flex flex-col items-center w-full container">
              <divider-component>Contact</divider-component>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="w-full flex flex-row items-center justify-center -mt-6">
      <div class="flex flex-row items-center justify-between md:w-5/12 w-5/6">
        <div
          class="md:w-80 md:h-52 w-36 bg-white rounded-md flex flex-col items-center text-center md:px-6 px-2 card-shadow"
        >
          <div class="mt-4 md:text-3xl text-xl text-pink-700">
            <fa :icon="['fas', 'phone']"></fa>
          </div>
          <div class="md:mt-6 mt-4 text-black font-800 md:text-lg text-xs">
            Bestelling plaatsen, reservatie boeken, dat kan!
          </div>
          <div class="md:mt-6 mt-4 text-pink-800 md:text-md text-sm font-medium mb-2">
            tel 03 298 88 13
          </div>
        </div>
        <div
          class="md:w-80 md:h-52 w-36 bg-white rounded-lg flex flex-col items-center text-center md:px-6 px-2 card-shadow"
        >
          <div class="mt-4 md:text-3xl text-xl text-pink-700">
            <fa :icon="['fas', 'envelope']"></fa>
          </div>
          <div class="md:mt-6 mt-4 text-black font-800 md:text-lg text-xs">
            Met vragen, informatie en andere dingen kan je ons mailen!
          </div>
          <div class="md:mt-6 mt-4 text-pink-800 md:text-md text-sm font-medium mb-2">
            Flavours@telenet.be
          </div>
        </div>
      </div>
    </section>
    <section class="title w-full flex flex-col items-center justify-center md:mt-20 mt-10">
      <h1 class="text-gray-600 font-semibold md:text-2xl text-xl text-center">
        En je vindt ons terug op volgend adres
      </h1>
      <div class="mt-8 text-4xl text-pink-700">
        <fa :icon="['fas', 'location-dot']"></fa>
      </div>

      <h2 class="text-gray-600 font-semibold md:text-2xl text-xl text-center mt-4 underline">
        <a
          class="flex flex-col"
          href="https://www.google.com/maps/place/Flavours/@51.2201131,4.281056,17z/data=!3m1!4b1!4m5!3m4!1s0x47c3f4db941c30f3:0xd64929a07f439cef!8m2!3d51.2201131!4d4.28325"
          target="_blank"
        >
          <span> Flavours Broodjeszaak</span>
          <span>Grote Baan 193A</span>
          <span>9120 Melsele</span></a
        >
      </h2>
    </section>

    <section class="w-full flex justify-center md:absolute md:bottom-6 md:my-0 mt-6 mb-4">
      <informational-text-component>
        Vragen i.v.m allergieën kan je in de zaak stellen of op onze
        <router-link to="/menu"><a class="text-pink-700 font-semibold">menu</a></router-link>
        bekijken
      </informational-text-component>
    </section>
  </article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DividerComponent from '@/components/util/Divider.component.vue';
import InformationalTextComponent from '@/components/util/informational-text.component.vue';

export default defineComponent({
  name: 'Contact-page',
  components: { DividerComponent, InformationalTextComponent },
});
</script>

<style lang="scss" scoped></style>
